module.exports = __webpack_public_path__ + "static/media/lightbulb.caa4356a.svg";